import { Component, EventEmitter, Input, OnInit, Output, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzUploadFile } from 'ng-zorro-antd/upload';
import { ProductService } from 'src/app/services/product.service';
import { EcatService } from 'src/app/services/ecat.service';
import { encryptParam } from 'src/app/utils/encrypt';
import { SharedTabDataService } from '../shared-tab-data-service.component';
import { RemarkMap, EcatUtils } from 'src/app/utils/ecat-util';
import { NzModalService } from 'ng-zorro-antd/modal';
import { NzImageService } from 'ng-zorro-antd/image';
import { VideoModalComponent } from 'src/app/pages/official-website/ecat/video/video-modal.component';
import { LoginService } from 'src/app/services/login.service';
import { UserData } from 'src/app/models/userData.model';
import { Router, ActivatedRoute } from '@angular/router';
import * as copy from 'copy-to-clipboard';

@Component({
  selector: 'app-part-detail-mobile',
  templateUrl: './part-detail-mobile.component.html',
  styleUrls: ['./part-detail-mobile.component.less']
})
export class PartDetailMobileComponent implements OnInit, OnDestroy {
  @Input() id!: number;
  @Output() goBackView = new EventEmitter<any>();
  @Input() activeTabIndex: number = 0;
  Math = Math;
  parseFloat = parseFloat;

  RemarkMap: any = RemarkMap;
  productData: any;
  partVOList: any[] = [];
  imageList: any[] = [];
  currentImageIndex = 0;
  isDetailLoading = false;
  isTableLoading = false;
  isMatchedTableLoading = false;
  packagingNoticeCategoryCodes = new Set(['BR003', 'EO001', 'EO002', 'EO005', 'EO006', 'EO007', 'WP010']);
  activeTab = 0; // 0: 技术参数, 1: 适配车型, 2: 原厂信息, 3: 安装限制, 4: 下载中心

  // Modal states
  isErrorReportVisible = false;
  isAllVehiclesVisible = false;

  // Forms
  errorReportForm!: FormGroup;

  // Matched cars data
  matchedCars: any[] = [];
  isFromAllMatchedCars = false;
  expandedBrands: Set<string> = new Set();

  // All vehicles data
  allBrands: any[] = [];
  allFilteredSeries: any[] = [];
  allFilteredModels: any[] = [];
  allFilteredDisplacements: any[] = [];
  allFilteredYears: any[] = [];
  selectedBrand: any = {};
  selectedSeries: any = {};
  selectedModel: any = {};
  selectedDisplacement: any[] = [];
  selectedYear: any[] = [];
  filteredVehicles: any[] = [];
  pageInfo: any = {};
  pageIndex = 1;
  pageSize = 10;
  selectedPartId = '';
  searchBySelectedCars = false;

  carIdOptions: any[] = [];
  isReportErrorVisible = false;
  selectedPartNo = '';
  selectedLevelIds = '';
  selectedVinCode = '';
  imageId = '';
  imageUri = '';

  // Upload
  fileList: NzUploadFile[] = [];
  subscription: any;

  // Cart bottom drawer
  isCartBottomVisible: boolean = false;
  isLogin: boolean = false;
  userData: UserData | undefined;
  questionContent = '';

  constructor(
    private productService: ProductService,
    private fb: FormBuilder,
    private message: NzMessageService,
    private ecatService: EcatService,
    private sharedData: SharedTabDataService,
    private modal: NzModalService,
    private router: Router,
    private route: ActivatedRoute,
    private loginService: LoginService,
    private nzImageService: NzImageService
  ) {
    this.initForms();
  }

  ngOnInit(): void {
    this.selectedPartId = this.route.snapshot.paramMap.get('partId') || history.state.partId;
    this.searchBySelectedCars = history.state.searchBySelectedCars;
    if (this.selectedPartId) {
      this.checkLoginStatus();
      this.getMatchedCars();
    } else {
      this.router.navigate(['gb/cn/parts/ecat-search']);
      return;
    }
  }

  checkLoginStatus(): void {
    this.loginService.userData$.subscribe((userData: UserData | null) => {
      this.userData = userData || undefined;
      this.isLogin = !!userData;
    });
  }

  getMoq(): number {
    return this.productData?.minimumOrderQuantity || this.productData?.minumQty || 1;
  }

  getImageDescription(): string {
    const categoryCode = this.productData?.categoryCode;
    if (categoryCode && this.packagingNoticeCategoryCodes.has(categoryCode)) {
      return '图片仅供参考，当前市场上同时存在新老包装产品，以实物为准';
    }
    return '图片仅供参考，以实物为准';
  }

  decreaseQuantity(): void {
    if (!this.productData) return;
    const moq = this.getMoq();
    const currentQty = this.productData.quantity || moq;
    if (currentQty > moq) {
      this.productData.quantity = currentQty - moq;
    } else {
      this.productData.quantity = moq;
    }
  }

  increaseQuantity(): void {
    if (!this.productData) return;
    const moq = this.getMoq();
    this.productData.quantity = (this.productData.quantity || moq) + moq;
  }

  quantityBlur(newQuantity: number): void {
    if (this.productData) {
      this.productData.quantity = newQuantity;
    }
  }

  quantityChange(newQuantity: number): void {
    if (this.productData) {
      this.productData.quantity = newQuantity;
    }
  }

  openCartBottom(): void {
    if (!this.isLogin) {
      this.message.warning('请先登录');
      return;
    }
    // Initialize product data for cart
    if (this.productData && !this.productData.quantity) {
      this.productData.quantity = this.getMoq();
    }
    if (this.productData && !this.productData.expectedDate) {
      this.productData.expectedDate = new Date();
    }
    this.isCartBottomVisible = true;
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  goBack(): void {
    this.goBackView.emit();
  }

  initForms(): void {
    this.fileList = [];
    this.errorReportForm = this.fb.group({
      contactInfo: ["", [Validators.required]],
      subjectType: ["01", [Validators.required]],
      content: ["", [Validators.required, Validators.maxLength(500)]],
      agreeToPolicy: [false, [Validators.requiredTrue]],
      carIds: [[]],
      remark: ["", [Validators.maxLength(500)]],
    })
  }

  handleViewPrivacy(url: string, index?: number) {
    const country = localStorage.getItem("country");
    this.router.navigate([`${country ? country : '/iam'}${url}`], { queryParams: { index: index } });
  }

  resetForms(): void {
    this.fileList = [];
    this.errorReportForm.patchValue({
      contactInfo: "",
      remark: "",
      agreeToPolicy: false,
      content: this.questionContent
    })
  }

  getMatchedCars() {
    const selectedCarIds = history.state.selectedCarIds || '';
    const selectedCarArr = selectedCarIds
      .split(',')
      .map((s: string) => s.trim())
      .filter((s: string) => s !== '');
    this.isDetailLoading = true;
    if (this.searchBySelectedCars) {
      const isAllChecked = history.state.isAllChecked;
      this.ecatService.partCarQuery({
        carIds: selectedCarIds,
        partIds: this.selectedPartId.toString(),
        languageType: 'zh-cn'
      })
        .subscribe(result => {
          this.isDetailLoading = false;
          const { resultCode, resultData, resultMsg } = result;
          const partVOList = resultData.partVOList;
          partVOList.forEach((item: any) => {
            item?.partDTO?.partFeatureValueList?.forEach((feature: any) => {
              if (item?.partDTO?.category1Name?.includes('雨刮') &&
                (feature.featureNameCn === '雨刮1长度' ||
                  feature.featureNameCn === '雨刮2长度(仅套装)' ||
                  feature.featureNameCn === '长度 1' ||
                  feature.featureNameCn === '长度 2')
              ) {
                const regex = /(\d+(\.\d+)?)/;
                const match = feature.featureValue.match(regex);
                if (match) {
                  const number = parseFloat(match[0]);
                  const roundedNumber = number / 25.4;
                  feature.featureValue = `${roundedNumber}`;
                }
              }
            });
          });
          this.partVOList = partVOList;
          if (resultData.partVOList) {
            const partDto = resultData.partVOList[0].partDTO || [];
            this.productData = partDto;
            this.selectedPartNo = partDto?.partNo;
            const content = '料号【' + partDto?.partNo + '】存在配件匹配错误';
            this.questionContent = content;
            this.errorReportForm.controls['content'].setValue(content);
            // Initialize quantity and expectedDate for cart
            if (!this.productData.quantity) {
              this.productData.quantity = this.productData.minimumOrderQuantity || this.productData.minumQty || 1;
            }
            if (!this.productData.expectedDate) {
              this.productData.expectedDate = new Date();
            }
            this.imageList = resultData.partVOList[0].partDTO.imageList || [];
          }
          this.isReportErrorVisible = true;
          if (isAllChecked) {
            this.isFromAllMatchedCars = true;
            const passedBrandId = history.state.selectedBrandId;
            this.handleSearchMatchedCars(passedBrandId);
          } else {
            this.carIdOptions = selectedCarArr;
            this.errorReportForm.controls['carIds'].setValue(selectedCarArr);
            // Use exactly the same data source as PC
            this.matchedCars = resultData.partVOList[0].carDetailList;
            this.isFromAllMatchedCars = false;
          }
        });
    } else {
      const selectedLevelIds = history.state.selectedLevelIds;
      const vinCode = history.state.vinCode;
      this.selectedLevelIds = selectedLevelIds;
      this.selectedVinCode = vinCode;
      let params = {};
      if (vinCode) {
        this.isReportErrorVisible = true;
        this.carIdOptions = selectedCarArr;
        this.errorReportForm.controls['carIds'].setValue(selectedCarArr);
        params = {
          levelIds: selectedLevelIds,
          partIds: this.selectedPartId.toString(),
          languageType: 'zh-cn'
        }
      } else {
        params = {
          partIds: this.selectedPartId.toString(),
          languageType: 'zh-cn'
        }
      }
      this.ecatService.partCarQuery(params)
        .subscribe(result => {
          this.isDetailLoading = false;
          const { resultCode, resultData, resultMsg } = result;
          const partVOList = resultData.partVOList;
          partVOList.forEach((item: any) => {
            item?.partDTO?.partFeatureValueList?.forEach((feature: any) => {
              if (item?.partDTO?.category1Name?.includes('雨刮') &&
                (feature.featureNameCn === '雨刮1长度' ||
                feature.featureNameCn === '雨刮2长度(仅套装)' ||
                feature.featureNameCn === '长度 1' ||
                feature.featureNameCn === '长度 2')
              ) {
                const regex = /(\d+(\.\d+)?)/;
                const match = feature.featureValue.match(regex);
                if (match) {
                  const number = parseFloat(match[0]);
                  const roundedNumber = number / 25.4;
                  feature.featureValue = `${roundedNumber}`;
                }
              }
            });
          });
          this.partVOList = partVOList;
          if (resultData.partVOList) {
            const partDto = resultData.partVOList[0].partDTO || [];
            this.productData = partDto;
            this.selectedPartNo = partDto?.partNo;
            const content = '料号【' + partDto?.partNo + '】存在配件匹配错误';
            this.questionContent = content;
            this.errorReportForm.controls['content'].setValue(content);
            // Initialize quantity and expectedDate for cart
            if (!this.productData.quantity) {
              this.productData.quantity = this.productData.minimumOrderQuantity || this.productData.minumQty || 1;
            }
            if (!this.productData.expectedDate) {
              this.productData.expectedDate = new Date();
            }
            this.imageList = resultData.partVOList[0].partDTO.imageList || [];
          }
          this.isFromAllMatchedCars = true;
          this.handleSearchMatchedCars('');
        });
    }
  }

  // Get first 5 cars exactly like PC does - use the same data source
  getFirst5Cars(): any[] {
    if (!this.matchedCars || this.matchedCars.length === 0) {
      return [];
    }
    // Use exactly the same logic as PC: matchedCars.slice(0, 5)
    // This ensures we show the exact same 5 vehicles as PC
    return this.matchedCars.slice(0, 5);
  }

  // Group the first 5 cars by brand (same data, different display format)
  groupCarsByBrand(): { [key: string]: any[] } {
    const grouped: { [key: string]: any[] } = {};
    // Get first 5 cars exactly like PC - this is the key to ensure data consistency
    const carsToShow = this.getFirst5Cars();
    carsToShow.forEach((car: any) => {
      const brand = car.carBrandName || '其他';
      if (!grouped[brand]) {
        grouped[brand] = [];
      }
      // Maintain the original order within each brand
      grouped[brand].push(car);
    });
    return grouped;
  }

  getBrands(): string[] {
    // Ensure we're using the same first 5 cars as PC
    const carsToShow = this.getFirst5Cars();
    if (carsToShow.length === 0) {
      return [];
    }
    const grouped = this.groupCarsByBrand();
    // Return brands in the order they appear in the first 5 cars
    const brandOrder: string[] = [];
    const seenBrands = new Set<string>();
    carsToShow.forEach((car: any) => {
      const brand = car.carBrandName || '其他';
      if (!seenBrands.has(brand)) {
        seenBrands.add(brand);
        brandOrder.push(brand);
      }
    });
    return brandOrder;
  }

  getCarsByBrand(brand: string): any[] {
    const grouped = this.groupCarsByBrand();
    return grouped[brand] || [];
  }

  toggleBrand(brand: string): void {
    if (this.expandedBrands.has(brand)) {
      this.expandedBrands.delete(brand);
    } else {
      this.expandedBrands.add(brand);
    }
  }

  isBrandExpanded(brand: string): boolean {
    return this.expandedBrands.has(brand);
  }

  processData(partDTO: any) {
    if (partDTO !== null && partDTO !== undefined) {
      let rainWiperLengths = [];
      let displayFeature;
      let display1Feature;
      let display2Feature;
      const rainWiper1Feature = partDTO.partFeatureValueList && partDTO.partFeatureValueList.find((feature: any) => feature.featureNameCn === '长度 1（英寸）');
      const rainWiper2Feature = partDTO.partFeatureValueList && partDTO.partFeatureValueList.find((feature: any) => feature.featureNameCn === '长度 2（英寸）');
      if (rainWiper1Feature || rainWiper2Feature) {
        displayFeature = partDTO.partFeatureValueList.filter((feature: any) => feature.featureNameCn !== '雨刮1长度' && feature.featureNameCn !== '雨刮2长度(仅套装)' && feature.featureNameCn !== '长度 1' && feature.featureNameCn !== '长度 2');
        rainWiperLengths = displayFeature;
      } else {
        const rainWiper3Feature = partDTO.partFeatureValueList && partDTO.partFeatureValueList.find((feature: any) => feature.featureNameCn === '雨刮1长度');
        const rainWiper4Feature = partDTO.partFeatureValueList && partDTO.partFeatureValueList.find((feature: any) => feature.featureNameCn === '雨刮2长度(仅套装)');
        if (rainWiper3Feature || rainWiper4Feature) {
          display1Feature = partDTO.partFeatureValueList.filter((feature: any) => feature.featureNameCn !== '长度 1' && feature.featureNameCn !== '长度 2');
          rainWiperLengths = display1Feature;
        } else {
          display2Feature = partDTO.partFeatureValueList;
          rainWiperLengths = display2Feature;
        }
      }
      const isEmpty = (v: any) => v === null || v === undefined || v === '';
      return rainWiperLengths.filter((f: any) => !(isEmpty(f.featureValueString) && isEmpty(f.featureValue)) && f.featureNameCn !== '中心电极材料');
    } else {
      return [];
    }
  }

  editFeatureNameCn(featureNameCn: any): string {
    if (!featureNameCn) {
      return '';
    }
    const item = this.partVOList[0];
    if (item) {
      const isAllSize1 = item.partDTO.partFeatureValueList?.find((feature: any) => feature.featureNameCn === '雨刮1长度') && item.partDTO.partFeatureValueList?.find((feature: any) => feature.featureNameCn === '雨刮2长度(仅套装)');
      const isAllSize2 = item.partDTO.partFeatureValueList?.find((feature: any) => feature.featureNameCn === '长度 1') && item.partDTO.partFeatureValueList?.find((feature: any) => feature.featureNameCn === '长度 2');
      const isAllSize3 = item.partDTO.partFeatureValueList?.find((feature: any) => feature.featureNameCn === '长度 1（英寸）') && item.partDTO.partFeatureValueList?.find((feature: any) => feature.featureNameCn === '长度 2（英寸）');
      const isOnlySize1 = item.partDTO.partFeatureValueList?.find((feature: any) => feature.featureNameCn === '雨刮1长度');
      const isOnlySize2 = item.partDTO.partFeatureValueList?.find((feature: any) => feature.featureNameCn === '长度 1');
      const isOnlySize3 = item.partDTO.partFeatureValueList?.find((feature: any) => feature.featureNameCn === '长度 1（英寸）');
      if (isAllSize3) {
        if (featureNameCn === '长度 1（英寸）' || featureNameCn === '长度 1' || featureNameCn === '雨刮1长度') {
          return '主驾尺寸(英寸)';
        } else if (featureNameCn === '长度 2（英寸）' || featureNameCn === '长度 2' || featureNameCn === '雨刮2长度(仅套装)') {
          return '副驾尺寸(英寸)';
        }
      } else if (isAllSize1) {
        if (isOnlySize3) {
          return '尺寸(英寸)';
        } else {
          if (featureNameCn === '长度 1（英寸）' || featureNameCn === '长度 1' || featureNameCn === '雨刮1长度') {
            return '主驾尺寸(英寸)';
          } else if (featureNameCn === '长度 2（英寸）' || featureNameCn === '长度 2' || featureNameCn === '雨刮2长度(仅套装)') {
            return '副驾尺寸(英寸)';
          }
        }
      } else if (isAllSize2) {
        if (isOnlySize3 || isOnlySize1) {
          return '尺寸(英寸)';
        } else {
          if (featureNameCn === '长度 1（英寸）' || featureNameCn === '长度 1' || featureNameCn === '雨刮1长度') {
            return '主驾尺寸(英寸)';
          } else if (featureNameCn === '长度 2（英寸）' || featureNameCn === '长度 2' || featureNameCn === '雨刮2长度(仅套装)') {
            return '副驾尺寸(英寸)';
          }
        }
      } else if (isOnlySize3) {
        return '尺寸(英寸)';
      } else if (isOnlySize1) {
        if (!isAllSize3) {
          return '尺寸(英寸)';
        } else {
          if (featureNameCn === '长度 1（英寸）' || featureNameCn === '长度 1' || featureNameCn === '雨刮1长度') {
            return '主驾尺寸(英寸)';
          } else if (featureNameCn === '长度 2（英寸）' || featureNameCn === '长度 2' || featureNameCn === '雨刮2长度(仅套装)') {
            return '副驾尺寸(英寸)';
          }
        }
      } else if (isOnlySize2) {
        if (!isAllSize3 || !isAllSize1) {
          return '尺寸(英寸)';
        } else {
          if (featureNameCn === '长度 1（英寸）' || featureNameCn === '长度 1' || featureNameCn === '雨刮1长度') {
            return '主驾尺寸(英寸)';
          } else if (featureNameCn === '长度 2（英寸）' || featureNameCn === '长度 2' || featureNameCn === '雨刮2长度(仅套装)') {
            return '副驾尺寸(英寸)';
          }
        }
      }
    }
    return featureNameCn;
  }

  selectImage(index: number): void {
    if (this.imageList.length > 0 && index >= 0 && index < this.imageList.length) {
      this.currentImageIndex = index;
    }
  }

  getSingleImage(image: any) {
    if (image !== '') {
      return 'https://spiderbeast2.blob.core.chinacloudapi.cn/pim-attachment/' + image.imageName;
    } else {
      return 'assets/official-website/no-image.png';
    }
  }

  getImage(imageList: any) {
    if (imageList.length > 0) {
      return 'https://spiderbeast2.blob.core.chinacloudapi.cn/pim-attachment/' + imageList[this.currentImageIndex].imageName;
    } else {
      return 'assets/official-website/no-image.png';
    }
  }

  // 点击主图时放大预览：展示全部图片并从当前 currentImageIndex 开始，支持左右切换浏览。
  previewCurrentImage(): void {
    if (!this.imageList || this.imageList.length === 0) {
      return;
    }
    const images = this.imageList.map(item => ({ src: this.getSingleImage(item) }));
    const previewRef = this.nzImageService.preview(images);
    const index = Math.min(Math.max(this.currentImageIndex, 0), images.length - 1);
    previewRef.switchTo(index);
  }

  copyProductCode(): void {
    if (this.productData) {
      if (copy(this.productData?.partNo)) {
        this.message.create('success', '复制成功');
      } else {
        this.message.create('error', '复制失败');
      }
    }
  }

  copyPartCode(partNo: any): void {
    const textToCopy = partNo.map((item: any) => item.partNo).join(' ');
    if (copy(textToCopy)) {
      this.message.create('success', '复制成功');
    } else {
      this.message.create('error', '复制失败');
    }
  }

  showErrorReportModal(): void {
    this.isErrorReportVisible = true;
  }

  handleErrorReportCancel(): void {
    this.isErrorReportVisible = false;
    this.resetForms();
  }

  handleErrorReportSubmit(): void {
    if (!this.errorReportForm.get('agreeToPolicy')?.value) {
      this.message.create('warning', '请阅读并同意相关的隐私条款');
    }
    if (this.errorReportForm.valid) {
      const formValue = this.errorReportForm.value;
      const partId = this.selectedPartId;
      const partNo = this.selectedPartNo;
      const params = {
        ...formValue,
        partId,
        partNo,
        languageType: "zh-cn",
        levelIds: this.selectedLevelIds,
        vinCode: this.selectedVinCode,
        imageId: this.imageId,
        imageUri: this.imageUri,
      };
      this.ecatService.submitErrorReport(params).subscribe({
        next: () => {
          this.message.success("报错信息提交成功");
          this.isErrorReportVisible = false;
          this.resetForms();
        },
        error: () => {
          this.message.error("提交失败，请重试");
        },
      });
    } else {
      Object.values(this.errorReportForm.controls).forEach((control: any) => {
        if (control.invalid) {
          control.markAsDirty();
          control.updateValueAndValidity({ onlySelf: true });
        }
      });
    }
  }

  getMatchedBrands() {
    this.ecatService.getBrand({
      partId: this.selectedPartId,
      languageType: 'zh-cn'
    })
      .subscribe(result => {
        const { resultCode, resultData, resultMsg } = result;
        this.allBrands = resultData.carBrand;
      });
  }

  handleSearchMatchedCars(brandId: string) {
    this.isMatchedTableLoading = true;
    const params = {
      page: this.pageIndex,
      pageSize: this.pageSize,
      partId: encryptParam(this.selectedPartId.toString()),
      brandId: encryptParam(brandId ? brandId : ''),
      languageType: encryptParam('zh-cn')
    };
    this.ecatService.carQuery(params).subscribe(result => {
      this.isMatchedTableLoading = false;
      const { resultCode, resultData } = result;
      // Use exactly the same data source as PC
      this.matchedCars = resultData.carInfoList;
    });
  }

  openVideoModal(categoryName: string, remark: string): void {
    let videoUrl = RemarkMap[categoryName as keyof typeof RemarkMap]?.[remark as keyof typeof RemarkMap[keyof typeof RemarkMap]];
    this.modal.create({
      nzTitle: '视频播放',
      nzContent: VideoModalComponent,
      nzComponentParams: {
        videoUrl: videoUrl
      },
      nzFooter: null,
      nzWidth: 800
    });
  }

  getRemarks(remark: string, categoryName: string) {
    return EcatUtils.mapRemark(remark, categoryName);
  }

  isVideoModal(remark: any) {
    const nonVideoList = ['AP1', 'AP3', 'AP4', 'AP6', '2AA', '2BB', '2CC', '1A', '1B', '2A', '2C'];
    if (nonVideoList.includes(remark)) {
      return true;
    } else {
      return false;
    }
  }

  hasVideoUrl(categoryName: string, remark: string) {
    return RemarkMap[categoryName as keyof typeof RemarkMap]?.[remark as keyof typeof RemarkMap[keyof typeof RemarkMap]];
  }

  beforeUpload = (file: NzUploadFile): boolean => {
    const formData = new FormData();
    formData.append('file', file as any);
    this.ecatService.uploadFile(formData).subscribe(result => {
      const { resultCode, resultData, success, resultMsg } = result;
      if (success) {
        this.imageId = resultData.fileDTO.fileId;
        this.imageUri = resultData.fileDTO.fileUri;
        this.fileList = [file];
      } else {
        this.message.create('warning', resultMsg);
      }
      console.log('resultData', resultData)
    });
    return false
  }

  removeFile = (file: NzUploadFile): boolean => {
    this.fileList = this.fileList.filter((f) => f !== file);
    return true;
  }
}

